import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './ToastButton.scss';

/**
 * Common Moo style ToastButton that can be extended.
 */

const ToastButtonComponent = (props) => {
  const className = classNames('toast-button-component', 'u-fontFamily-primaryMedium', {
    'toast-button-component--loading': props.loading,
    'toast-button-component--failed': props.failed,
    'toast-button-component--success': props.success,
    'toast-button-component__error': props.error,
  });
  const click = () => {
    if (!props.loading && !props.success && !props.failed) {
      props.toastAction();
    }
  };

  return (
    <div className={className} disabled={props.loading || props.success || props.failed} onClick={click}>
      {props.children}
    </div>
  );
};

ToastButtonComponent.displayName = 'ToastButton';

ToastButtonComponent.propTypes = {
  children: PropTypes.object,
  toastAction: PropTypes.func.isRequired,
  error: PropTypes.bool,
  loading: PropTypes.bool,
  success: PropTypes.bool,
  failed: PropTypes.bool,
};

export default ToastButtonComponent;
